(function ($, Drupal) {

  // Use strict mode.
  'use strict';

  /**
   * Declare our media_nav behavior.
   *
   * @type {{attach: Drupal.behaviors.media_nav.attach}}
   */
  Drupal.behaviors.media_nav = {
    attach: function (context, settings) {
      // Selects mediaFacetsNavbar and stores it in navbar.
      const $navbar = $('#mediaFacetsNavbar');
      const $window = $(window);

      // Calculate the distance from the top of the page to the navbar.
      const distance = $navbar.offset().top;

      // When the user scrolls the page run function.
      $window.scroll(function() {
        // Check the distance from the top of the page to the navbar.
        if ($window.scrollTop() >= distance) {
          // Remove the fixed position from the navbar and add it back.
          $navbar.removeClass('fixed-top').addClass('fixed-top');

          // Make sure that we have added the padding-top.
          $("body").css("padding-top", "70px");
        }
        else {
          // Remove the fixed position from the navbar.
          $navbar.removeClass('fixed-top');

          // Make sure that we have removed the padding-top.
          $("body").css("padding-top", "0px");
        }
      });
    }
  };

})(jQuery, Drupal);
